import React from 'react';
import { getLabel } from '../../../data/labels';
import { getConfiguration, getCurrencySymbol, getPrintableAmount } from '../../utils';

function TuplesDetail(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);

    function getAmountWithCurrency(amount) {
        return `${getPrintableAmount(amount, conf.cs.m, conf.cs.nd)} ${currency}`;
    }

    const selections = [];
    Object.keys(props.selections).forEach(k => {
        const s = props.selections[k];
        if (s.selected === true) {
            s.key = k;
            selections.push(s);
        }
    });

    return (
        <div className="selection">
            {selections.map(s => {
                return (
                    <div className="tuples-info d-flex flex-column text-small grey">
                        <div className="d-flex justify-content-between">
                            <div>{getLabel('mybets.sistema')}: <span className="text-bold">{`${s.key}-pla`}</span></div>
                            <div>{getLabel('mybets.combinazioni')}: <span className="text-bold">{props.combs[s.key]}</span></div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div>{getLabel('mybets.importo')}: <span className="text-bold">{getAmountWithCurrency(s.amount)}</span></div>
                            <div>{getLabel('mybets.vincitaminima')}: <span className="text-bold">{getAmountWithCurrency(s.vMin)}</span></div>
                            <div>{getLabel('mybets.vincitamassima')}: <span className="text-bold">{getAmountWithCurrency(s.vMax)}</span></div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default TuplesDetail;